import {AssertionUtils, TimeUtils} from '@vdw/angular-component-library';
import {DateTime, Duration} from 'luxon';
import {BreakTime} from '../pattern/break-time';
import {PatternShift} from '../pattern/pattern-shift';
import {Shift} from '../shift/shift';

export class ScheduleException extends PatternShift {
  private _date: DateTime;

  public constructor(id: number | string, shift: Shift, date: DateTime, startTime: Duration, endTime: Duration, breakTimes: BreakTime[], originalSequence?: number, occurrenceOfShift?: number) {
    super(id, undefined, shift, startTime, endTime, breakTimes, undefined, occurrenceOfShift, originalSequence);
    this._date = date;
  }

  public get date(): DateTime {
    return this._date;
  }

  public set date(value: DateTime) {
    this._date = value;
  }

  public static fromJSON(exceptionJSON: any): ScheduleException {
    return new ScheduleException(
      exceptionJSON.id,
      AssertionUtils.isNullOrUndefined(exceptionJSON.shift) ? null : Shift.fromJSON(exceptionJSON.shift),
      TimeUtils.convertToLocalDateTime(DateTime.fromISO(exceptionJSON.date)),
      AssertionUtils.isNullOrUndefined(exceptionJSON.startTimeFromMidnight) ? null : TimeUtils.convertTimeSpanToDuration(exceptionJSON.startTimeFromMidnight),
      AssertionUtils.isNullOrUndefined(exceptionJSON.endTimeFromMidnight) ? null : TimeUtils.convertTimeSpanToDuration(exceptionJSON.endTimeFromMidnight),
      exceptionJSON.breakTimes?.map((breakTimeJSON: any) => BreakTime.fromJSON(breakTimeJSON)),
      exceptionJSON.originalSequence,
      exceptionJSON.occurrenceOfShift
    );
  }

  public toJSON(): JSON {
    return {
      ...super.toJSON(),
      date: TimeUtils.convertToUTCDateTime(this._date).toISO(),
      originalSequence: this.originalSequence
    } as any as JSON;
  }
}
